import { useAppState, useAppDispatch } from './Context'
import LocationCard from './LocationCard'

function LocationList() {
  const dispatch = useAppDispatch()
  const { locations } = useAppState()

  const handleClick = (location) => {
    dispatch({ type: 'setSelectedLocation', payload: location })
  }

  return (
    <div className="overflow-scroll flex-1 pb-2 divide-white divide-y-[8px] overflow-scroll-touch">
      {locations.map((location) => (
        <LocationCard key={location.id} location={location} onClick={() => handleClick(location)} />
      ))}
    </div>
  )
}

export default LocationList
